import { render, staticRenderFns } from "./CfdisRelated.vue?vue&type=template&id=64e9ca72&scoped=true&"
import script from "./CfdisRelated.vue?vue&type=script&lang=js&"
export * from "./CfdisRelated.vue?vue&type=script&lang=js&"
import style0 from "./CfdisRelated.vue?vue&type=style&index=0&id=64e9ca72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e9ca72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64e9ca72')) {
      api.createRecord('64e9ca72', component.options)
    } else {
      api.reload('64e9ca72', component.options)
    }
    module.hot.accept("./CfdisRelated.vue?vue&type=template&id=64e9ca72&scoped=true&", function () {
      api.rerender('64e9ca72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/CFDI/CfdisRelated.vue"
export default component.exports